import { z } from "zod";

export const TermsType = {
  TermsOfUse: "terms_of_use",
  PrivacyPolicy: "privacy_policy",
} as const;

export const termsTypeSchema = z.enum(TermsType);
export type TermsType = z.infer<typeof termsTypeSchema>;

export interface TermsDocument {
  id: string;
  type: TermsType;
  version: string;
  title: string;
  content: string;
  contentHash: string;
  publishedAt: string;
}

export interface PendingTerm {
  type: TermsType;
  version: string;
  title: string;
}

export interface TermsAcceptanceItem {
  type: TermsType;
  version: string;
}

export interface TermsAcceptance {
  id: string;
  type: TermsType;
  version: string;
  contentHash: string;
  acceptedAt: string;
}

export interface AcceptTermsResult {
  accessToken: string;
  refreshToken: string;
  pendingTerms: PendingTerm[];
}
